import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-vclaim";

async function getDataKunjungan(tgl, layananId) {
  const response = await http
    .getData(`/monitoring/data-kunjungan/tanggal/${tgl}/pelayanan/${layananId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

export default {
  getDataKunjungan
};
